import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const origOnError = window.onerror;
window.onerror = (msg) => {
  if (typeof msg === "string" && msg.includes("ResizeObserver")) return true;
  return origOnError ? origOnError(msg) : false;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
